var React = require('react');

function LoginIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"8.99967","cy":"4.66667","r":"3.66667","stroke":"black","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M17 20C17 15.5817 13.4183 12 9 12C4.58172 12 1 15.5817 1 20","stroke":"black","strokeWidth":"2","key":1})]);
}

LoginIcon.defaultProps = {"width":"18","height":"20","viewBox":"0 0 18 20","fill":"none"};

module.exports = LoginIcon;

LoginIcon.default = LoginIcon;
